const permissions = Object.freeze({
  SESSIONS: {
    MANAGE: 'sessions:manage',
    REGISTER: 'sessions:register'
  }
});

export default permissions;
